/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BooleanResource
 */
export interface BooleanResource {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResource
     */
    value: boolean;
}

/**
 * Check if a given object implements the BooleanResource interface.
 */
export function instanceOfBooleanResource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function BooleanResourceFromJSON(json: any): BooleanResource {
    return BooleanResourceFromJSONTyped(json, false);
}

export function BooleanResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BooleanResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function BooleanResourceToJSON(value?: BooleanResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

